export default "__VITE_ASSET__CgHtgAoR__"